import { render, staticRenderFns } from "./OrderRoom.vue?vue&type=template&id=4ea2c585&scoped=true&"
import script from "./OrderRoom.vue?vue&type=script&lang=js&"
export * from "./OrderRoom.vue?vue&type=script&lang=js&"
import style0 from "./OrderRoom.vue?vue&type=style&index=0&id=4ea2c585&scoped=true&lang=css&"
import style1 from "./OrderRoom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea2c585",
  null
  
)

export default component.exports